import { useEffect, useRef } from 'react';

// Custom hook to get the previous value of a prop or state
export function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
